<template>
    <div>
        <div class="actions-tab in-tab">
            <b-dropdown variant="link" class="info" right toggle-class="text-decoration-none" no-caret style="margin-right: 83px;">
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-info"></i>
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
            </b-dropdown>
            <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-download"></i> Скачать
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-item @click="downloadRep">Пояснительная записка</b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="table-container">
            <b-table
                :items="formApp"
                :fields="tableFields"
                responsive
                bordered
                head-variant="light"
                no-border-collapse
                sticky-header="true"
                class="text-center"
            >
                <template #thead-top="data">
                    <b-tr>
                        <b-th colspan="3" class="text-center"></b-th>
                        <b-th colspan="1" class="text-center">{{ 'Факт, тыс. теңге' }}</b-th>
                        <b-th colspan="1" class="text-center">{{ 'Оценка, тыс. теңге' }}</b-th>
                        <b-th colspan="3" class="text-center">{{ 'Прогноз, тыс. теңге' }}</b-th>
                        <b-th colspan="1" class="text-center"></b-th>
                    </b-tr>
                </template>
                <template #cell(code)="data">
                    <div class="text-center">{{ data.value }}</div>
                </template>
                <template #cell(name_ru)="data">
                    <div class="text-left">{{ data.value }}</div>
                </template>
                <template #cell(row_code)="data">
                    <div class="text-center">{{ data.value }}</div>
                </template>
                <template #cell()="data">
                    <div class="text-right">
                        <template v-if="data.item.row_code !== 100">
                            <input type="number"
                                   v-model.number="data.value"
                                   @blur="blurInput(data, data.item.row_code, data.item.code)"
                                   :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                   :disabled="access_level === 1 || !actualVersion"
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </template>
                        <template v-else>
                            <span
                                v-if="err = hasError(data.field.key)"
                                :title="err.text"
                                class="warning-icon"
                            >⚠</span>
                            {{ data.value || '' }}
                        </template>
                    </div>
                </template>
                <template #cell(actions)="data">
                    <template v-if="data.item.row_code !== 100 && (access_level === 2 || access_level === 3)">
                        <b-dropdown v-if="access_level === 2 || access_level === 3" id="dropdown-dropleft"
                                    dropright class="more">
                            <template v-slot:button-content>
                                <i class="icon icon-more"></i>
                            </template>
                            <b-dropdown-item @click="editCode(data.item.row_code, true)">
                                Редактировать
                            </b-dropdown-item>
                            <b-dropdown-item  @click="removeRow(data.index, data.item.code)" class="remove">
                                Удалить
                            </b-dropdown-item>
                        </b-dropdown>
                    </template>
                </template>

                <template #bottom-row>
                    <b-tr>
                        <b-td colspan="8" class="text-center td-add-button">
                            <span
                                class="add-link-button"
                                @click="openAddModal">
                            <i class="icon icon-plus-circle"></i>Добавить строку
                            </span>
                        </b-td>
                    </b-tr>
                </template>
            </b-table>
        </div>
        <b-modal id="code-modal"
                 ref="modalRef"
                 size="lg"
                 centered
                 modal-class="multiselect-modal modal-table"
        >
            <template #modal-header="{ close }">
                <div class="title">Выберите вид товара</div>
                <i class="icon icon-close" @click="close()"></i>
            </template>
            <div class="card-modal-multiselect">
            <b-form-group class="m-0 form-group-divider label-bold">
                <multiselect
                    :options="filteredCodeOptions"
                    v-model="selectedCode"
                    track-by="value"
                    label="label"
                    :placeholder="isEdit ? `${isEditItem.selectedCode}` : 'Введите код товара'">
                </multiselect>
            </b-form-group>
            </div>

            <template #modal-footer>
                <div class="w-100 text-center">
                    <b-button
                        v-if="!isEdit"
                        variant="success"
                        size="sm"
                        @click="AddNewLine"
                    >ОК
                    </b-button>
                    <b-button
                        v-if="isEdit"
                        variant="success"
                        size="sm"
                        @click="EditLine"
                    >Изменить
                    </b-button>
                </div>
            </template>
        </b-modal>

        <loading
            :active="loading"
            is-full-screen
            spinner="bar-fade-scale"
            color="#6495ED"
        />
    </div>
</template>
<script>

import VueElementLoading from "vue-element-loading";
import moment from "moment";
import {Ax} from "@/utils";

export default {
    name: 'forecast-note-table35',
    components: {
        'loading': VueElementLoading
    },
    props: {
        year: Number,
        region: String,
        version: String,
        abp: Number,
        dataType: Number,
        region_name: String,
        version_name: String,
        obl: String,
        actualVersion: Boolean,
        access_level: Number,
        table_number: Number,
        table_code: String,
        checkDataList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            loading: false,
            open: false,
            allOpen: false,
            inputValues: [],
            deleteValues: [],
            formApp: [
                {
                    row_code: 100,
                    is_total: true,
                    name_ru: 'Всего доходов от реализации товаров (работ, услуг)',
                    fact: 0,
                    evaluation: 0,
                    forecast_1: 0,
                    forecast_2: 0,
                    forecast_3: 0,
                }
            ],
            codeOptions: [],
            selectedCode: null,
            isEdit: false,
            isEditItem: null

        }
    },
    async mounted() {
        await this.LoadCodeOptions();
        await this.LoadDataTable35();
    },
    computed: {
        filteredCodeOptions() {
            const usedCodes = this.formApp
                .filter(row =>
                    !this.isEdit || row.row_code !== this.isEditItem?.row_code
                )
                .map(row => row.code);

            return this.codeOptions.filter(
                option => !usedCodes.includes(option.value)
            );
        },
        forecastYears() {
            return [this.year - 2, this.year - 1, this.year, this.year + 1, this.year + 2];
        },
        tableFields() {
            const [yearMinus2, yearMinus1, currentYear, yearPlus1, yearPlus2] = this.forecastYears;

            return [
                {
                    key: 'code',
                    label: 'Код вида товаров (работ, услуг)',
                    rowspan: 2,
                    thStyle: { width: '300px' }
                },
                {
                    key: 'name_ru',
                    label: 'Наименование вида товаров (работ, услуг)',
                    rowspan: 2
                },
                {
                    key: 'row_code',
                    label: 'Код строки',
                    rowspan: 2
                },
                {
                    key: 'fact',
                    label: String(yearMinus2),
                    rowspan: 1
                },
                {
                    key: 'evaluation',
                    label: String(yearMinus1),
                    rowspan: 1
                },
                {
                    key: 'forecast_1',
                    label: String(currentYear)
                },
                {
                    key: 'forecast_2',
                    label: String(yearPlus1)
                },
                {
                    key: 'forecast_3',
                    label: String(yearPlus2)
                },
                {
                    key: 'actions',
                    label: '',
                    thStyle: { width: '40px' }
                }

            ];
        }
    },
    methods: {
        hasError(field) {
            return this.checkDataList.find(item =>
                item.agreed_form === 'note' && item.table === '35' &&
                item[field]
            );
        },
        openAddModal() {
            this.isEdit = false;
            this.isEditItem = null;
            this.selectedCode = null;

            this.$bvModal.show('code-modal');
        },
        editCode(option, isEdit){
            this.isEdit = isEdit;
            this.isEditItem = this.formApp.find(item => item.row_code === option);

            if (this.isEditItem) {
                this.selectedCode = this.codeOptions.find(opt =>
                    opt.value === this.isEditItem.code
                ) || null;
            }

            this.$bvModal.show('code-modal');
        },
        AddNewLine() {
            const detailRows = this.formApp.filter(row => !row.is_total)
            const nextNumber = detailRows.length + 11

            const nextCode = String(nextNumber).padStart(3, '0')

            this.formApp.push({
                code: this.selectedCode.value,
                row_code: nextCode,
                is_total: false,
                name_ru: this.selectedCode.name_ru,
                fact: null,
                evaluation: null,
                forecast_1: null,
                forecast_2: null,
                forecast_3: null
            })
            this.selectedCode = null;
            this.isEdit = false;
            this.isEditItem = null;
            this.$bvModal.hide('code-modal');
        },
        EditLine() {
            if (!this.isEditItem || !this.selectedCode) return;

            this.$set(this.isEditItem, 'code', this.selectedCode.value);
            this.$set(this.isEditItem, 'name_ru', this.selectedCode.name_ru);

            this.selectedCode = null;
            this.isEdit = false;
            this.isEditItem = null;
            this.$bvModal.hide('code-modal');
        },
        // удаление данных
        removeRow(index, code) {
            this.$bvModal.msgBoxConfirm(
                'Удаленная запись не подлежит восстановлению. Вы уверены?',
                {
                    title: 'Подтверждение',
                    size: 'lg',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Да',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            )
                .then(value => {
                    if (value) {
                        this.formApp.splice(index, 1);
                        let entry = this.deleteValues.find(e => e.code === code);

                        if (!entry) {
                            entry = {code};
                            this.deleteValues.push(entry);
                        }
                    }
                })
                .catch(error => {
                    this.makeToast('danger', 'Ошибка удаления', error.toString());
                });
        },
        blurInput(data, line_code, code, isInitialLoad = false) {
            const field = data.field.key;
            const rawValue = data.value;
            let newValue;
            if (rawValue === undefined || rawValue === null || rawValue === "") {
                newValue = 0;
            } else {
                newValue = parseFloat(rawValue) || 0;
            }

            const childRow = this.formApp.find(r => r.row_code === line_code);
            if (!childRow) return;
            const originalValue = childRow[field];

            this.$set(childRow, field, newValue);

            const totalRow = this.formApp.find(r => r.row_code === 100);
            if (!totalRow) return;

            const sum = this.formApp
                .filter(r => r.row_code !== 100)
                .reduce((acc, row) => {
                    return acc + (parseFloat(row[field]) || 0);
                }, 0);

            this.$set(totalRow, field, sum);

            if (isInitialLoad) return;
            // inputValues (для сохранения)

            if (newValue === 0) {
                if (originalValue === null || originalValue === undefined || originalValue === '' || originalValue === 0) {
                    return;
                }
            }
            let entry = this.inputValues.find(e => e.code === code);

            if (!entry) {
                entry = {code};
                this.inputValues.push(entry);
            }
            this.$set(entry, field, newValue);
        },
        async LoadCodeOptions() {
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_code_options_for_table35/`);
                if (response.status === 200) {
                    const data = await response.json();

                    this.codeOptions = data.map(item => ({
                        value: item.code,
                        label: `${item.code} - ${item.name_ru}`,
                        name_ru: item.name_ru
                    }));

                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки Таблицы', error.toString());
            }
            this.loading = false;
        },
        async LoadDataTable35() {
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_note_tables35/` + this.year +  '/' + this.version + '/' + this.abp);
                if (response.status === 200) {
                    const data = await response.json();

                    const totalRow = {
                        row_code: 100,
                        is_total: true,
                        name_ru: 'Всего доходов от реализации товаров (работ, услуг)',
                        fact: 0,
                        evaluation: 0,
                        forecast_1: 0,
                        forecast_2: 0,
                        forecast_3: 0,
                    };

                    const rows = data.filter(r => r.row_code !== 100);
                    const renumberedRows = rows.map((row, index) => {
                        const newNumber = 11 + index;
                        const newRowCode = String(newNumber).padStart(3, '0');

                        const option = this.codeOptions.find(opt =>
                            opt.value === row.code
                        );

                        return {
                            ...row,
                            row_code: newRowCode,
                            name_ru: option ? option.name_ru : null
                        };
                    });


                    this.formApp = [
                        totalRow,
                        ...renumberedRows
                    ];

                    const keysToBlur = ['fact', 'evaluation', 'forecast_1', 'forecast_2', 'forecast_3'];

                    this.formApp.forEach(row => {
                        keysToBlur.forEach(key => {
                            if (row[key] !== undefined) {
                                this.blurInput(
                                    {
                                        item: row,
                                        field: { key },
                                        value: row[key]
                                    },
                                    row.row_code, row.code, true
                                );
                            }
                        });
                    });
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки Таблицы', error.toString());
            }
            this.loading = false;
        },
        async SaveData() {
            if (Object.keys(this.inputValues).length > 0 || Object.keys(this.deleteValues).length > 0) {
                this.inputData = [];
                const item = Object.assign({});

                this.$set(item, 'inputValues', this.inputValues);
                this.$set(item, 'deleteValues', this.deleteValues);
                this.$set(item, 'cur_year', this.year);
                this.$set(item, 'budget_variant', this.version);
                this.$set(item, 'abp', this.abp);
                this.$set(item, 'user_id', this.$store.getters.user_uuid);
                this.$set(item, 'update_date', moment().format('YYYY-MM-DD'));
                this.$set(item, 'region_code', this.region);
                this.$set(item, 'data_type', this.dataType);
                this.$set(item, 'table_num', 35);
                this.isLoad = true;
                this.inputData.push(item);
                try {
                    const response = await fetch('/api-py/add_data_to_pkfo_note35', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(this.inputData)
                    });
                    const result = await response.json();
                    if (response.status === 200 && result.result === 'success') {
                        this.isSave = false;
                        this.makeToast('success', 'Сообщение', 'Данные сохранены');
                    } else {
                        if (result.result === 'error') {
                            throw 'Ошибка сохранения данных.';
                        }
                    }
                } catch (e) {
                    this.makeToast('danger', 'Предупреждение', e.toString());
                } finally {
                    this.isLoad = false;
                }
            }
        },
        downloadRep() {
            try {
                this.makeToast('info', 'Внимание!', 'Скоро начнется скачивание. Пожалуйста ожидайте.');
                this.isLoad = true;
                this.curParams = { year: this.year, region: this.region, version: this.version, data_type: this.dataType, abp: this.abp, reg_name: this.region_name, ver_name: this.version_name, table_num: '35', table_code: this.table_code };
                Ax(
                    {
                        url: '/api-py/forecast_reporting_note_tables/' + JSON.stringify(this.curParams),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        const fileName = 'Пояснительная записка.xlsx';
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                    },
                    (error) => {
                        this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                    }
                );
            } catch (error) {
                console.log(error)
                this.makeToast('danger', 'Предупреждение', 'Необходимо заполнить все обязательные фильтры!');
            } finally {
                this.isLoad = false
            }
        },
        toNum(value, fix = 1) {
            if (typeof value === 'string') {
                if (value.trim() === '') {
                    return 0; // или можно вернуть null, если не хочешь показывать 0
                }
                const num = parseFloat(value.replace(',', '.'));
                return isNaN(num) ? 0 : parseFloat(num.toFixed(fix));
            }
            if (typeof (value) === 'number') {
                return parseFloat(value.toFixed(fix));
            }
            if (typeof (value) === 'boolean') {
                return (value === true ? 1 : 0);
            }
            if (typeof (value) === 'undefined') {
                return 0;
            }
            if (isNaN(value)) {
                return 0;
            }
            if (isFinite(value)) {
                return 0;
            }
            if (value === null) {
                return 0;
            }
        },
        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        }

    }
}
</script>


